import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import ReactAutocomplete from 'react-autocomplete';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  fetchPostsIfNeeded,
  selectSearch
} from '../../actions/SearchActions';

import {
  SearchBarWrapper,
  SearchDropdown
} from '../HelperComponents/StyledComponents';

const doneTypingInterval = 300;
const inputClasses = 'input is-large search-bar--input';

class SearchComponent extends Component {
  static propTypes = {
    dispatch: PropTypes.any,
    searchSelected: PropTypes.any,
    history: PropTypes.any
  }

  state = {
    value: ''
  }

  requestTimer = null

  handleSubmit = (event) => {
    this.props.history.push(`/results/${encodeURIComponent(this.state.value)}`);
    this.props.dispatch({ type: 'CLEAR_POSTS' });
    clearTimeout(this.requestTimer);

    // also, clear the input.
    this.clearInput();

    event.preventDefault();
  }

  clearInput() {
    this.setState({
      value: '',
    });
  }

  render() {
    return (
      <Fragment>
        <SearchBarWrapper
          className="field search-component is-paddingless"
          searchBackgroundColor={this.props.searchBackgroundColor}
          searchPlaceholderAlign={this.props.searchPlaceholderAlign}
        >
          <form onSubmit={this.handleSubmit}>
            <ReactAutocomplete
              wrapperStyle={{ display: 'block', position: 'relative' }}
              items={_.uniqBy(this.props.items, 'title')}
              shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
              getItemValue={item => item.title}
              renderInput={(props) => {
                // We want two differnt placeholder texts for desktop and mobile.
                // It doesn't seem to cause an issue to have two inputs. So just hide and show them
                // for different screen sizes.
                return (
                  <section className="control">
                    <label htmlFor="searchInputMobile" className="is-hidden-tablet" aria-label="Search">
                      <input
                        id="searchInputMobile"
                        className={`${inputClasses} is-hidden-tablet`}
                        placeholder=" Search by keyword"
                        {...props}
                      />
                    </label>
                    <label htmlFor="searchInput" className="is-hidden-mobile" aria-label="Search">
                      <input
                        id="searchInput"
                        className={`${inputClasses} is-hidden-mobile`}
                        placeholder=" Or search by keyword"
                        {...props}
                      />
                    </label>
                  </section>
                )
              }}
              renderItem={(item, highlighted) =>
                <section
                  key={item.id}
                  style={{ backgroundColor: highlighted ? '#222' : 'transparent', padding: '15px' }}
                >
                  <Link to={`/results/${encodeURIComponent(item.title)}`} onClick={() => {
                    this.props.dispatch({ type: 'CLEAR_POSTS' });
                  }}>
                    <p>{item.title}</p>
                  </Link>
                </section>
              }
              renderMenu={(items, value) => {
                let hasLessThanTen = this.props.items.length > 10;
                return (
                  <SearchDropdown className="has-text-white" theme={{ height: hasLessThanTen ? '50vh' : '', visibility: this.state.value ? 'visible' : 'hidden', zIndex: 100 }}>
                    {value === '' ? (
                      <div className="item" style={{padding: '15px' }}></div>
                    ) : this.state.loading ? (
                      <div className="item">Loading...</div>
                    ) : items.length === 0 ? (
                      <div className="item" style={{padding: '15px' }}>No matches for {value}</div>
                    ) : items}
                  </SearchDropdown>
                );
              }}
              value={this.state.value}
              onChange={e => {
                let fieldValue = e.target.value;

                this.setState({ value: fieldValue })
                clearTimeout(this.requestTimer);

                this.requestTimer = setTimeout(() => {

                  this.props.dispatch(selectSearch(fieldValue));
                  this.props.dispatch(fetchPostsIfNeeded(fieldValue));
                }, doneTypingInterval);
              }}
              onSelect={value => {
                // clear the input and go to new url
                this.clearInput();
                this.props.history.push(`/results/${encodeURIComponent(value)}`);
              }}
            />
            <button type="submit" style={{ display: 'none' }}>
            </button>
          </form>

        </SearchBarWrapper>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { searchSelected, search } = state;
  const {
    isFetching,
    lastUpdated,
    items
  } = search[searchSelected] || {
    isFetching: true,
    items: []
  };

  return {
    searchSelected,
    items,
    isFetching,
    lastUpdated
  };
}

export const Search = withRouter(connect(mapStateToProps)(SearchComponent));



// WEBPACK FOOTER //
// ./src/components/Search/SearchComponent.js